import { useTranslation } from 'react-i18next';

export const SessionLoader = () => {
  const { t } = useTranslation('index');
  return (
    <div
      className='flex min-h-screen-safe items-center justify-center'
      role='status'
      aria-label={t('aria.loading-page')}
    >
      <span className='text-muted-foreground'>{t('states.loading')}</span>
    </div>
  );
};
